import CryptoJS from 'crypto-js';

export type RecipientPublicKey = {
  recipientUserId: string;
  recipientKeyId: string;
  publicKeyBase64: string;
};

export type WrappedRecipientEnvelope = {
  recipientUserId: string;
  recipientKeyId?: string;
  senderKeyId?: string;
  scheme: string;
  wrappedKeyBase64: string;
};

function deriveWrapKey(publicKeyBase64: string, senderKeyId: string): CryptoJS.lib.WordArray {
  return CryptoJS.SHA256(`${publicKeyBase64}:${senderKeyId}`);
}

export function wrapContentKeyForRecipient(args: {
  recipientUserId: string;
  recipientKeyId?: string;
  recipientPublicKeyBase64: string;
  senderKeyId: string;
  contentKeyBase64: string;
}): WrappedRecipientEnvelope {
  const wrapKey = deriveWrapKey(args.recipientPublicKeyBase64, args.senderKeyId);
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(
    args.contentKeyBase64,
    wrapKey,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  const wrappedKeyBase64 =
    CryptoJS.enc.Base64.stringify(iv) +
    "." +
    CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

  return {
    recipientUserId: args.recipientUserId,
    recipientKeyId: args.recipientKeyId,
    senderKeyId: args.senderKeyId,
    scheme: "aes-cbc-derived-wrap-v1",
    wrappedKeyBase64,
  };
}
